import React, { useState } from "react";
import { Modal, Button } from 'react-bootstrap';

import { useLoveFestApi } from '../../_common/hooks/api/loveFestApiHook';

import { useForm } from "react-hook-form";


const CheckoutThanksModal = (props: Record<string, any>) => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const loveFestApi = useLoveFestApi();

    const onPinboardSubmit = (data: any) => {
        loveFestApi.addUpdateInspoBoard(data, (message: any, resp: any) => {
            console.log('resp', resp.pinboard.id);
            loveFestApi.addToInspoBoard({
                item_id: props.id,
                item_type: 'product',
                pinboard_id: resp.pinboard.id,
            }, (message: any, resp: any) => {
                props.update();
                props.onHide();
                props.onUpdate();
            }, (message: any, resp: any) => {
                console.error(message)
            })
        }, (message: any, resp: any) => {
            console.error(message)
        })
    }
    const addToBoard = (board: any) => {
        loveFestApi.addToInspoBoard({
            item_id: props.id,
            item_type: 'product',
            pinboard_id: board.id,
        }, (message: any, resp: any) => {
            props.update();
            props.onHide();
        }, (message: any, resp: any) => {
            console.error(message)
        })
    }



    const getBoardBtn = (board: any) => {
        let btn: any = <Button variant="outline-info" type="button" size="sm" onClick={() => { addToBoard(board) }}>Use</Button>
        console.log('------', props.pined)
        props.pined?.forEach((pin: any) => {
            if (pin) {
                if (pin.id === board.id) {
                    btn = <Button variant="outline-danger" type="button" size="sm" onClick={() => { addToBoard(board) }}>Remove</Button>
                }
            }

        })
        return btn;
    }

    return (
        <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered className="add-review-modal" >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">Order</Modal.Title>
            </Modal.Header>
            <Modal.Body className="add-inspo">

                <p>Thanks for the order</p>


            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide} variant="dark">Close</Button>
            </Modal.Footer>
        </Modal>
    )
};

export default CheckoutThanksModal


